angular.module('angus.services')
    .factory('actionViews', function() {
        return {
            getActionView: function(widgetCode, viewName) {
                return ('templates/widgets/{0}/html/actionViews/{1}.html').format(widgetCode, viewName || 'default');
            }
        };
    });